<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    name: string
    size?: 'sm' | 'md' | 'lg'
    tone?: 'accent' | 'soft'
  }>(),
  { size: 'md', tone: 'soft' },
)

/** Iniciály ze jména, e-mailu i přezdívky — bere první dva srozumitelné kusy. */
const initials = computed(() => {
  const parts = props.name.split(/[\s.@_-]+/).filter(Boolean)
  const letters = parts.slice(0, 2).map((part) => part[0]?.toUpperCase() ?? '')
  return letters.join('') || '?'
})
</script>

<template>
  <span
    class="avatar"
    :class="[`avatar--${size}`, `avatar--${tone}`]"
    :title="name"
    aria-hidden="true"
  >
    {{ initials }}
  </span>
</template>

<style scoped>
.avatar {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  border-radius: var(--radius-full);
  font-weight: 650;
  letter-spacing: 0.01em;
}

.avatar--sm { width: 24px; height: 24px; font-size: 10.5px; }
.avatar--md { width: 30px; height: 30px; font-size: 11.5px; }
.avatar--lg { width: 44px; height: 44px; font-size: 15px; }

.avatar--soft { background: var(--accent-soft); color: var(--accent); }
.avatar--accent { background: var(--accent); color: var(--accent-text); }
</style>
